import { useEffect, useState } from 'react';
type Theme = 'light' | 'dark';

const mq = window.matchMedia('(prefers-color-scheme: dark)');

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') return stored;
    return mq.matches ? 'dark' : 'light';
  });

  // Apply class whenever theme changes
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  // Real-time OS preference listener
  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => {
      if (!localStorage.getItem('theme')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    try {
      localStorage.setItem('theme', next);
    } catch {
      // best-effort persistence; storage errors must not block the UI update
    }
  };
  return { theme, toggleTheme };
};
